import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import HomeView from './HomeView';
import crmServices from '../../wsclient/crmservices'
import { setCurrency, setContacts, logOut, setRefreshWalletListener, getCurrency, getContacts } from '../../utils/common';
import AllotmentDetailView from './AllotmentDetailView';
import { getAppCfg } from '../../utils/common'
import AllotmentDetail from './AllotmentDetail';
import Transactions from '../transactions/Transactions';
import OfferDetail from '../offers/OfferDetail';
import BarcodeView from './BarcodeView';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import ServiceRequestsController from '../service-requests/ServiceRequestsController';
import ModalConfirm from '../../components/ModalConfirm';
import t from '../../utils/translateUtil';
import AddCard from '../reward-cards/AddCard';
import {domainName, portal_config} from '../../../portal.config'
const styles = theme => ({

});
function Home(props){
    const [active, setActive] = useState('home');
    const [showBarcode, setShowBarcode] = useState(false);
    const [authentication_code, setAuthenticationCode] = useState('');
    const [wallet, setWallet] = useState({});
    const [rewards, setReward] = useState({});
    const [offers, setOffers] = useState([]);
    const [paging, setPaging] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [contactName, setContactName] = useState('');
    const [showOfferDetai, setShowOfferDetail] = useState(false);
    const [showAllotmentDetail, onShowAllotmentDetail] = useState(false);
    const [offer, setOffer] = useState(null);
    const [tier_progress, setTierProgress] = useState({
        current_tier_name: "",
        color: null,
        percentage:0,
        remaining_value_units:0,
        next_tier_name:"",
        has_next_value:false
    });

    const [showLoading, onShowLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [showServiceRequests, onShowServiceRequests] = useState(false);
    const [confirm, setConfirm] = useState({});
    const [showAddCardReward, setShowAddCardReward] = useState(false);

    const [subscriptions, setSubscriptions] = useState(null);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [subscriptionsFilter, setSubscriptionsFilter] = useState(null);
    const [accountBalance, setAccountBalance] = useState(null);

    const app_config = getAppCfg();
    const reward_tiering = app_config && app_config.features && app_config.features.rewards_details && app_config.features.rewards_details.reward_tiering ? app_config.features.rewards_details.reward_tiering : false;
    const isShowOffer = app_config&&app_config.features ? app_config.features.rewards : false;
    const ordering = app_config && app_config.features.ordering ? app_config.features.ordering: false;
    
    const currency = getCurrency() ? getCurrency() : portal_config.default_currency;


    useEffect(()=>{
        checkRewardCard();
        onLoadContact();
        onLoadWallet();
        loadOffer();
        setRefreshWalletListener(onLoadWallet);
       if(reward_tiering){ 
        onLoadRewards();
       }
       if(ordering){
           onLoadAddress();
       }
       if(domainName == 'airlink'){
            onInitSubscriptions();
       }
    },[]);

    const checkRewardCard = async() => {
        onShowLoading(true);
        try{
            if(app_config && app_config.return_cashback){
                let resultCards = await crmServices.contacts.getListPaymentMethods();
                console.log("resultCards:",resultCards);
                if(resultCards.code == 'OK'){
                    let data = resultCards.data && resultCards.data.content ? resultCards.data.content : [];
                    let cardRewardExist = data.filter(card => {
                        return card.payment_method_type == 'CARD'
                    })
                    if(!cardRewardExist || cardRewardExist.length == 0){
                        setConfirm({ 
                            show: true, 
                            tilte: t('warning'), 
                            message: t('message_bank_card'),
                            actionTitle: t('add_a_card_now'),
                            cancelTitle: t('cancel')
                        });
                    }else {
                        setConfirm({});
                    }
                }
            }
        }catch(error){
            console.log("contacts getListPaymentMethods exception:", error);
        }
        onShowLoading(false);
    }
    const onLoadContact = async () => {
        try {
            let result = await crmServices.contacts.getContact();
            //console.log("Home AAAAAA load contact:", result);
            if (result.code === 'OK') {
                setContacts(result.data);
                setAuthenticationCode(result.data.code);
                setContactName(result.data.first_name);
            }
            else if(result.code === 'UNKNOWN'){
                logOut();
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }
    const onLoadWallet = async () => {
        try {
            let result = await crmServices.account.getWalletInfo();
            console.log("AAAAAA load wallet:",result);
            if (result.code === 'OK') {
                console.log("AAAAAA result.data.currency_code:",result.data.currency_code);
                setAccountBalance(result.data);
                setWallet(result.data.wallet);
                let contactInfo = getContacts();
                if(contactInfo && contactInfo.country_agreement == 'TTO') setCurrency('TT$')
                else if(contactInfo && contactInfo.country_agreement == 'GUY') setCurrency('GY$')
                else setCurrency(currency)
                //setCurrency(result.data.currency_code ? result.data.currency_code : currency);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadRewards = async() => {
        try {
            let result = await crmServices.account.getRewards();
            //console.log("AAAAAA load reward:",result);
            if (result.code === 'OK') {
                setReward(result.data);
                updateTier(result.data);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }
    const updateTier = (rewards) => {
        console.log("rewards:", rewards);
        if (rewards && rewards.reward_tier) {
            let tier_progress = dataUtil.getCurrentTier(rewards.reward_tier);
            setTierProgress(tier_progress);
        }
    }

    const loadOffer = async(params) => {
        //console.log('loadOffer== params=',params)
        onShowLoading(true);
        try {
            let result = await crmServices.rewards.getOffers({ ...params });
            console.log('loadOffer== ',result)
            if (result.code === 'OK') {
                let new_offers = result.data && result.data.content ? result.data.content : [];
                let newOffers = [];
                if (new_offers.length > 0) {
                    for (let i = 0; i < new_offers.length; i++) {
                        let offer_data = new_offers[i];
                        if(offer_data.is_featured){
                            if(offer_data.performance_enabled){ 
                                let performanceData = await loadPerformance(offer_data.id);
                                offer_data.performance_data = performanceData;
                            }
                            newOffers.push(offer_data);
                        }
                        
                    }
                }
                setOffers([...offers,...newOffers]);
                setPaging(result.data.paging);
                if(result.data.content.length ===0)
                    setHasMore(false);
            }
        } catch (error) {
            console.log("load offer exception:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async () => {
        //console.log("handleLoadMore============paging==",paging)

        let params = {...paging}
        params.page = params.page+1
        params.size = 10
        try{
            onShowLoadMore(true);
            try {
                let result = await crmServices.rewards.getOffers({ ...params });
                //console.log('loadOffer== ',result)
                if (result.code === 'OK') {
                    let new_offers = result.data && result.data.content ? result.data.content : [];
                    let newOffers = [];
                    if (new_offers.length > 0) {
                        for (let i = 0; i < new_offers.length; i++) {
                            let offer_data = new_offers[i];
                            if(offer_data.is_featured){
                                if(offer_data.performance_enabled){ 
                                    let performanceData = await loadPerformance(offer_data.id);
                                    offer_data.performance_data = performanceData;
                                }
                                newOffers.push(offer_data);
                            }

                        }
                    }
                    setOffers([...offers,...newOffers]);
                    setPaging(result.data.paging);

                    if(result.data.content.length ===0)
                        setHasMore(false);
                }
            } catch (error) {
                console.log("load offer exception:", error);
            }
            onShowLoadMore(false);
        }catch(error){
            console.log("Offers Load More Exception:",error);
        }
    }
    const loadPerformance = async (offerId) => {
        let performance_data = null;
        try {
            let result = await crmServices.rewards.getPerformanceOffer(offerId);
            if (result.code === 'OK') {
                performance_data = result.data;
            }
        } catch (error) {
            console.log("load offer exception:", error);
        }
        return performance_data;
    }
    const onLoadAddress = async () => {
        try {
            let result = await crmServices.contacts.getAddresses();
           // console.log("onLoadAddress result",result);
            if (result.code === 'OK') {
                let addresses = result.data && result.data.content ? result.data.content : [];
                setAddresses(addresses);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onShowBarcode = () => {
        setShowBarcode(!showBarcode);
        onShowAllotmentDetail(false);
    }

    const onShowOfferDetail = (offer) => {
        setShowOfferDetail(true);
        setOffer(offer);
    }

    const goToAddCard = () => {
        setConfirm({});
        setShowAddCardReward(true);
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubscriptions = async () => {
        onShowLoading(true);
        let subscriptionServices =[];
        try {
            const result = await crmServices.contacts.getListContactServices();
            console.log("result getListContactServices:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if (product) {
                        let info = await crmServices.orders.getProductDetail(product.id);
                        // console.log("product info:", info);
                        if (info.code == 'OK') {
                            // console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                        }
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            // console.log("subscriptionServices:", subscriptionServices);
            //if need filter
            setSubscriptions(subscriptionServices);
            setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
            setSubscriptionsFilter(dataUtil.groupServicesByMonth(subscriptionServices));
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        onShowLoading(false);
        return subscriptionServices;
    }

    const handleLoadMoreServices = async () => {
        
    }

    const onInitSubscriptions = async () => {
        let data = await onLoadSubscriptions();
        if (data && data.length > 0) {
            let periodData = dataUtil.groupBillingPeriod(data);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
            }
        }
    }

    return (
        <div>
            <HomeView
                onShowBarcode={onShowBarcode}
                showBarcode={showBarcode}
                wallet={wallet}
                currency = {currency}
                rewards = {rewards}
                ordering = {ordering}
                offers = {offers}
                addresses = {addresses}
                onShowAllotment = {()=>onShowAllotmentDetail(true)}
                contactName = {contactName}
                onShowOfferDetail = {onShowOfferDetail}
                tier_progress={tier_progress}
                reward_tiering={reward_tiering}
                showLoading = {showLoading}
                handleLoadMore = {handleLoadMore}
                hasMore = {hasMore}
                showLoadMore = {showLoadMore}
                isShowOffer = {isShowOffer}
                subscriptions={subscriptions}
                subscriptionsFilter={subscriptionsFilter}
                periodSelected={periodSelected}
                periods={periods}
                accountBalance={accountBalance}
                handleLoadMoreServices={handleLoadMoreServices}
                onChangeTab={onChangeTab}
                onShowServiceRequests={()=>onShowServiceRequests(true)}/>
            {showOfferDetai&&<OfferDetail 
                open={showOfferDetai}
                offer = {offer}
                handleDrawerToggle= {()=>setShowOfferDetail(false)}/>}
            {showAllotmentDetail&&<AllotmentDetail
                open = {showAllotmentDetail}
                wallet={wallet}
                currency={currency}
                onCloseAllotment={()=>onShowAllotmentDetail(false)} />}
            <BarcodeView
                open = {showBarcode}
                onShowBarcode={onShowBarcode}
                authentication_code = {authentication_code} />
            {showServiceRequests && <ServiceRequestsController 
                open={showServiceRequests}
                onClose={()=>onShowServiceRequests(false)}/>
                }    
            {showAddCardReward && <AddCard 
                open={showAddCardReward}
                onClose={()=> setShowAddCardReward(false)}
            />}
            {confirm && <ModalConfirm
                    open={confirm.show}
                    onClose={() => setConfirm({})}
                    message={confirm.message}
                    confirm={confirm.actionTitle}
                    buttonLabel={confirm.cancelTitle}
                    onAction={() => goToAddCard()}
                />}
        </div>

    );
}


export default withStyles(styles)(withTranslation()(Home));